import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import {UsersService} from "./shared/users.service";
import {User} from "./shared/user";

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.css']
})
export class UsersComponent implements OnInit {

  private users: User[] = [];
  key: string = "";
  form: FormGroup = new FormGroup({
      key: new FormControl()
  });

  constructor(private usersService: UsersService) { }

  ngOnInit() {
    this.usersService.getUsers(this.key)
      .subscribe(data => this.users = data);
  }

  deleteUser(user){
    if (confirm("Are you sure you want to delete " + user.name + "?")) {
      var index = this.users.indexOf(user);
      this.users.splice(index, 1);

      this.usersService.deleteUser(user.name)
        .subscribe(null,
          err => {
            alert("Could not delete user.");
            // Revert the view back to its original state
            this.users.splice(index, 0, user);
          });
    }
  }

  search(){
    this.key = this.form.value.key;
    this.usersService.getUsers(this.key)
      .subscribe(data => this.users = data);
  }
}



// WEBPACK FOOTER //
// ./src/app/users/users.component.ts